import React, { useState } from "react";
import { columns } from "./columnsTable";
import { DataTable } from "../../components";
import { Row, Button } from "antd";
import { useTranslation } from "react-i18next";
import { actionsRender } from "./actionRender";
import { useNavigate } from "react-router-dom";
import { VerticalAlignTopOutlined } from "@ant-design/icons";
import { onScrollTop } from "../../../utils/scrollTop";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import { UsersActions } from "../../../redux/users";

export const UsersTable = ({ valueList }) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const dispatch = useDispatch();

  const { t } = useTranslation();

  const { current, pageSize, sorterFilter } = useSelector(state => state.users);

  const onPaginationChange = (current, pageSize, record, sorterFilter) => {
    dispatch(UsersActions.changeTablePagesize(current, pageSize, sorterFilter));
  };

  const handleReset = () => {
    setSelectedRowKeys([]);
  };

  /*const onModify = center => {
    navigateTo(`/users/${center.id}`);
  };*/

  const onDelete = ids => {
    console.log("onDelete", ids)
    //dispatch(UsersActions.usersDeleteRequest(ids));
    //setSelectedRowKeys([]);
  };

  const handleOnActionRender = () => {
    return actionsRender(handleReset, onDelete, selectedRowKeys, t);
  };

  const resendRequest = id => {
    dispatch(UsersActions.resendRequest(id));
  };

  return (
    <div>
      <DataTable
        items={valueList}
        columns={columns({resendRequest, onDelete, sorterFilter, t})}
        actionsRender={handleOnActionRender}
        setSelectedRowKeys={setSelectedRowKeys}
        selectedRowKeys={selectedRowKeys}
        current={current}
        pageSize={pageSize}
        onPaginationChange={onPaginationChange}
      />
      <Row className="user-table-button-container">
        <Button
          type="primary"
          shape="circle"
          icon={<VerticalAlignTopOutlined />}
          onClick={onScrollTop}
        />
      </Row>
    </div>
  );
};
